<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title" style="width: 130px">公众号/推广链</span>
        <el-input v-model="parameter.app_id" />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">运营组</span>
        <el-autocomplete
          v-model="parameterNames.operation_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营组'"
          @clear="operation_group_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">运营者</span>
        <el-autocomplete
          v-model="parameterNames.operation_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营者'"
          @clear="operation_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">短剧</span>
        <el-autocomplete
          v-model="parameterNames.novel_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '短剧'"
          @clear="novel_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="position_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出总计报表</el-button>
    </div>
    <div class="content1">
      <div>
        合计
      </div>
      <div>
        <div>新用户充值：</div>
        <div>{{ tableData.total_data && tableData.total_data.new_user_recharge ? tableData.total_data.new_user_recharge : 0 }}</div>
      </div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.total_consume ? tableData.total_data.total_consume : 0 }}</div>
      </div>
      <div>
        <div>新用户roi：</div>
        <div>{{ tableData.total_data && tableData.total_data.new_user_roi ? tableData.total_data.new_user_roi : 0 }}</div>
      </div>
      <div>
        <div>总充值roi：</div>
        <div>{{ tableData.total_data && tableData.total_data.total_user_roi ? tableData.total_data.total_user_roi : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="channel_date"
          label="日期范围"
          width="150"
        />
        <el-table-column
          prop="wechat_names"
          label="公众号/推广链"
          min-width="250"
        >
          <template scope="scope">
            <ExpandClose :my-values="JSON.parse(scope.row.wechat_names)" />
          </template>
        </el-table-column>
        <el-table-column
          prop="release_group_name"
          label="投放组"
          width="120"
        />
        <el-table-column
          prop="operation_group_name"
          label="运营组"
          width="120"
        />
        <el-table-column
          prop="pitcher_name"
          label="投手姓名"
        />
        <el-table-column
          prop="platform_name"
          label="书城平台"
          width="120"
        />
        <el-table-column prop="position_name" label="投放位置" />
        <el-table-column
          prop="novel_name"
          label="短剧"
          width="120"
        />

        <el-table-column prop="roi_standard" label="ROI标准" />
        <el-table-column prop="compliance_rate" label="ROI达标率" width="120">
          <template scope="scope">
            {{ scope.row.compliance_rate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="consume"
          label="总消耗"
        />
        <el-table-column
          prop="new_user_recharge_commission"
          label="新用户充值（扣除佣金）"
          min-width="200"
        />
        <el-table-column prop="new_user_roi" label="新用户roi" width="120">
          <template scope="scope">
            <span style="color:red; font-weight: bold;">{{ scope.row.new_user_roi }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_recharge_commission"
          label="累积充值（扣除佣金）"
          width="180"
        />
        <el-table-column
          prop="today_back"
          label="总充值roi"
          width="120"
        >
          <template scope="scope">
            {{ scope.row.today_back }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="payment_growth_rate"
          label="付费增长率"
          width="120"
        >
          <template scope="scope">{{ scope.row.payment_growth_rate }}%</template>
        </el-table-column>
        <el-table-column prop="merits" label="有效绩效" width="120" />
        <el-table-column prop="scan_follow_count" label="企微客服人数" width="120" />
        <el-table-column prop="scan_follow_cost" label="企微客服成本" width="120" />
        <el-table-column prop="from_follow_count" label="公众号关注人数" width="140" />
        <el-table-column prop="from_follow_cost" label="公众号关注成本" width="140" />
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { getTotalReportList, getTheListOfOfficialAccount, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getShortPlayList, dropLocationList, modifyConsumption, exportTotalReport } from '@/api/shortPlayReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        novel_id: null,
        position_id: null
      },
      parameterNames: {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        novel_id_name: null, // 短剧
        position_id_name: null // 投放位置
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {}
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getTotalReportList({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '公众号': 'account_name',
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '运营组': 'operation_group_name',
        '运营者': 'user_name',
        '短剧': 'name',
        '投放位置': 'position_name'
      }

      switch (this.current) {
        case '公众号': currentFunc = getTheListOfOfficialAccount
          break
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组': currentFunc = getOperationGroupList
          break
        case '运营者': currentFunc = getOperatorList
          break
        case '短剧': currentFunc = getShortPlayList
          break
        case '投放位置': currentFunc = dropLocationList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '运营者' && !this.parameter.operation_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '运营者': '请先选运营组，才能选运营者'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const requestObj = this.current === '短剧' ? { novel_name: queryString || null, page: 1 } : {
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        type: this.current === '投放组' ? 2 : null
      }
      const data = await currentFunc(requestObj)
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '运营组' : this.parameter.operation_group_id = item
          break
        case '运营者' : this.parameter.operation_id = item
          break
        case '短剧' : this.parameter.novel_id = item
          break
        case '投放位置' : this.parameter.position_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        novel_id: 'novel_id_name',
        position_id: 'position_id_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'pageSize' && key !== 'app_id') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'pageSize' && key !== 'app_id') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })

      value === '导出' || this.getDataList(obj1)
      return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        novel_id: null,
        position_id: null
      }
      this.parameterNames = {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        novel_id_name: null, // 短剧
        position_id_name: null // 投放位置
      }
      this.date = []
      this.current = null
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReport({ ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumption({ id: this.activeItem.id, consume: this.activeText })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}

 .powder {
   background: rgb(248, 216, 216);
 }
 .green {
   background: rgb(52, 229, 54);
 }
 .yellow {
   background: rgb(255, 247, 173);
 }
 .blue {
   background: rgb(158, 211, 252);
 }
 .red {
   background: #ffa500;
 }
 .magRig {
   margin-right: 10px;
 }
 .magLfte {
   margin-left: 10px;
 }
 .chong{
          display: inline-block;
          width: 13px;
          height: 86%;
          margin-left: 6px;
    }
    .mybox{
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>
